import { createSlice } from "@reduxjs/toolkit";
import { InitialStateMatrizConfig } from "./model";

const initialState: InitialStateMatrizConfig = {
  fromScreen: "",
  configTabs: {
    tabInView: 0,
    tabs: [
      {
        title: "Campos detalhe",
        index: 0,
        active: true,
        name: "camposDetalhe",
      },
      {
        title: "Detalhes Pedido",
        index: 1,
        active: true,
        name: "detalhesPedido",
      },
    ],
  },
};

const matrizConfigSlice = createSlice({
  name: "matrizConfigApp/matrizConfig",
  initialState,
  reducers: {
    changeTabMatrizConfig: (state, action) => {
      state.configTabs.tabInView = action.payload;
    },
  },
});

export const { changeTabMatrizConfig } = matrizConfigSlice.actions;

export default matrizConfigSlice.reducer;
